import React from 'react'
import './styles.css'
import DeliveryIcon from '../Assets/box.png'

function DirectionsData({directionsData}) {
    
    function getCost(){
        const cost = (0.5*(directionsData.duration.value)/60) + 1.5*(directionsData.distance.value)/1000
        console.log(cost,cost.toFixed(2))
        return cost.toFixed(2)
    }
    
    return (
        <div className = "directions-data">
        
       
        <div className = "directions-data-container">
           
           
            {/* <div className = "directions-data-content"> */}
            <div>
             <img src = {DeliveryIcon} alt = 'delivery icon' style = {{maxWidth:'80px',fontSize:'20px'}}/>
            </div>
            
            <div  id = 'info'className = "directions-data-title">
                <h3>Poli Express</h3>
                <p>Tempo: {directionsData.duration.text}</p>
                {/* <p>Distância: {directionsData.distance.text}</p> */}

            </div>
 
            <div>
            <h3>R$ {getCost()}</h3>
            </div>
            {/* </div> */}
        </div>


        </div>
    )
}

export default DirectionsData
